module.exports = __webpack_public_path__ + "img/metier-03.88054427.jpg";